module.exports = __webpack_public_path__ + "static/media/wand.070a8913.svg";